import { getAuthData } from "../features/auth/session.js";
// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import * as React from "react";
import * as jsxRuntime from "react/jsx-runtime";
import { RatingAvatar } from "../components/RatingAvatar.jsx";
import { PublicProfileModal } from "../components/PublicProfileModal.jsx";
export { RatingAvatar } from "../components/RatingAvatar.jsx";
import { IconDiamond } from "../components/icons.jsx";
import { IconBolt } from "../components/icons.jsx";
import { IconRefresh } from "../components/icons.jsx";
import { IconCrown } from "../components/icons.jsx";
export const jx = 120 * 1e3;
export const Uo = new Map();
export function cachedBoard(u) {
  const o = Uo.get(u);
  return o ? Date.now() - o.cachedAt < jx ? o.board : (Uo.delete(u), null) : null;
}
export const xx = [{
  id: "forbes",
  label: "Форбс"
}, {
  id: "universe",
  label: "Вселенная"
}, {
  id: "total",
  label: "Общий"
}];
export function remainingSeasonTime() {
  const u = new Date(),
    o = new Date(u.getTime() + 10800 * 1e3),
    m = Date.UTC(o.getUTCFullYear(), o.getUTCMonth() + 1, 1) - 10800 * 1e3;
  return Math.max(0, m - u.getTime());
}
export function RatingLaurel() {
  return jsxRuntime.jsxs("svg", {
    className: "mc-rating-laurel",
    viewBox: "0 0 100 100",
    fill: "none",
    "aria-hidden": "true",
    children: [jsxRuntime.jsx("path", {
      d: "M43 88C13 79 7 45 23 22M57 88C87 79 93 45 77 22",
      stroke: "currentColor",
      strokeWidth: "1.4"
    }), [0, 1, 2, 3, 4, 5].map(u => jsxRuntime.jsx("g", {
      transform: `rotate(${-u * 12} 50 50)`,
      children: jsxRuntime.jsx("ellipse", {
        cx: "15",
        cy: "47",
        rx: "3",
        ry: "8",
        transform: "rotate(-30 15 47)",
        fill: "currentColor"
      })
    }, u)), [0, 1, 2, 3, 4, 5].map(u => jsxRuntime.jsx("g", {
      transform: `rotate(${u * 12} 50 50)`,
      children: jsxRuntime.jsx("ellipse", {
        cx: "85",
        cy: "47",
        rx: "3",
        ry: "8",
        transform: "rotate(30 85 47)",
        fill: "currentColor"
      })
    }, u))]
  });
}
export function RatingScore({
  points: u,
  mode: o
}) {
  return jsxRuntime.jsxs(jsxRuntime.Fragment, {
    children: [u.toLocaleString("ru-RU"), " ", o === "forbes" ? jsxRuntime.jsx(IconDiamond, {
      "aria-label": "кристаллов оценочной стоимости"
    }) : jsxRuntime.jsx("small", {
      children: "PTS"
    })]
  });
}
export function RatingPage({
  onBack: u,
  player: o
}) {
  const [selectedPlayer, setSelectedPlayer] = React.useState(null);
  const [m, r] = React.useState("total"),
    [g, j] = React.useState(() => cachedBoard(`${o.id}:total`)),
    [B, U] = React.useState(() => !cachedBoard(`${o.id}:total`)),
    [N, y] = React.useState(null),
    [X, M] = React.useState(0),
    [R, H] = React.useState(remainingSeasonTime),
    Y = window.Telegram?.WebApp?.BackButton;
  React.useEffect(() => {
    const back = selectedPlayer ? () => setSelectedPlayer(null) : u;
    if (Y) return Y.show(), Y.onClick(back), () => {
      Y.offClick(back), Y.hide();
    };
  }, [Y, u, selectedPlayer]), React.useEffect(() => {
    const w = window.setInterval(() => H(remainingSeasonTime()), 6e4);
    return () => window.clearInterval(w);
  }, []), React.useEffect(() => {
    const w = () => M(I => I + 1);
    return window.addEventListener("rating-avatar-synced", w), () => window.removeEventListener("rating-avatar-synced", w);
  }, []), React.useEffect(() => {
    const w = getAuthData();
    if (!w) {
      y("Откройте рейтинг через Telegram."), U(!1);
      return;
    }
    const I = new AbortController(),
      ne = `${o.id}:${m}`,
      oe = cachedBoard(ne);
    return j(oe), y(null), U(!oe), fetch("/api/rating", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        initData: w,
        mode: m
      }),
      signal: I.signal
    }).then(async T => {
      if (!T.ok) throw new Error("Не удалось загрузить рейтинг.");
      return T.json();
    }).then(T => {
      I.signal.aborted || (Uo.set(ne, {
        board: T,
        cachedAt: Date.now()
      }), j(T), U(!1));
    }).catch(() => {
      I.signal.aborted || (oe || y("Не удалось загрузить рейтинг."), U(!1));
    }), () => I.abort();
  }, [m, X, o.id]);
  const P = `${Math.floor(R / 864e5)}д ${Math.floor(R % 864e5 / 36e5)}ч ${Math.floor(R % 36e5 / 6e4)}м`,
    W = g?.mode === m ? g : null,
    ee = W?.players.slice(0, 3) ?? [],
    ie = [ee[1], ee[0], ee[2]].filter(w => !!w);
  return jsxRuntime.jsxs("section", {
    className: "mc-rating-page",
    children: [jsxRuntime.jsxs("header", {
      children: [jsxRuntime.jsxs("h1", {
        children: ["Рейтинг", jsxRuntime.jsx("span", {
          "aria-hidden": "true",
          children: "✦"
        })]
      }), m !== "forbes" && jsxRuntime.jsxs("strong", {
        title: "Сезон PTS завершается 1-го числа в 00:00 по Москве",
        children: [jsxRuntime.jsx(IconBolt, {}), P]
      })]
    }), jsxRuntime.jsx("div", {
      className: "mc-rating-tabs",
      role: "tablist",
      "aria-label": "Вид рейтинга",
      children: xx.map(w => jsxRuntime.jsx("button", {
        type: "button",
        role: "tab",
        "aria-selected": m === w.id,
        className: m === w.id ? "active" : "",
        onClick: () => r(w.id),
        children: w.label
      }, w.id))
    }), B && jsxRuntime.jsx("p", {
      className: "mc-rating-status",
      role: "status",
      children: "Загружаем рейтинг…"
    }), N && jsxRuntime.jsxs("div", {
      className: "mc-rating-status",
      role: "alert",
      children: [jsxRuntime.jsx("p", {
        children: N
      }), jsxRuntime.jsxs("button", {
        type: "button",
        onClick: () => M(w => w + 1),
        children: [jsxRuntime.jsx(IconRefresh, {}), " Повторить"]
      })]
    }), W && jsxRuntime.jsxs(jsxRuntime.Fragment, {
      children: [ie.length > 0 && jsxRuntime.jsx("section", {
        className: "mc-rating-podium",
        "aria-label": "Призовая тройка",
        children: ie.map(w => jsxRuntime.jsxs("article", {
          className: `place-${w.place}${w.userId === o.id ? " is-me" : ""}`,
          children: [jsxRuntime.jsx("button", {
            type: "button",
            className: "mc-rating-profile-link",
            "aria-label": `Открыть профиль ${w.name}`,
            onClick: () => setSelectedPlayer({ ...w, ratingLabel: xx.find(tab => tab.id === m).label })
          }), jsxRuntime.jsx("div", {
            className: "mc-rating-podium-frame",
            "aria-hidden": "true"
          }), jsxRuntime.jsx("i", {
            className: "mc-rating-crown",
            "aria-hidden": "true",
            children: w.place === 1 ? jsxRuntime.jsx(IconCrown, {}) : "✦"
          }), jsxRuntime.jsx("strong", {
            className: "mc-rating-medal",
            "aria-label": `Место ${w.place}`,
            children: w.place
          }), w.userId === o.id && jsxRuntime.jsx("span", {
            className: "mc-rating-podium-me",
            children: "ВЫ"
          }), jsxRuntime.jsxs("div", {
            className: "mc-rating-portrait",
            children: [jsxRuntime.jsx(RatingLaurel, {}), jsxRuntime.jsx(RatingAvatar, {
              name: w.name,
              url: w.userId === o.id ? W.me.avatarVisible ? o.photoUrl || w.avatarUrl : null : w.avatarUrl,
              fallbackUrl: w.userId === o.id && W.me.avatarVisible ? w.avatarUrl : null
            })]
          }), jsxRuntime.jsx("b", {
            title: w.title ? `${w.name} · ${w.title}` : w.name,
            children: w.name
          }), jsxRuntime.jsx("em", {
            children: jsxRuntime.jsx(RatingScore, {
              points: w.points,
              mode: m
            })
          }), jsxRuntime.jsx("span", {
            className: "mc-rating-frame-star",
            "aria-hidden": "true",
            children: "✦"
          })]
        }, w.userId))
      }), W.players.length > 3 && jsxRuntime.jsx(jsxRuntime.Fragment, {
        children: jsxRuntime.jsx("section", {
          className: "mc-rating-list",
          "aria-label": "Таблица лидеров",
          children: W.players.slice(3).map(w => jsxRuntime.jsxs("article", {
            className: w.userId === o.id ? "is-me" : "",
            children: [jsxRuntime.jsx("button", {
              type: "button",
              className: "mc-rating-profile-link",
              "aria-label": `Открыть профиль ${w.name}`,
              onClick: () => setSelectedPlayer({ ...w, ratingLabel: xx.find(tab => tab.id === m).label })
            }), jsxRuntime.jsx("strong", {
              children: w.place
            }), jsxRuntime.jsx(RatingAvatar, {
              name: w.name,
              url: w.userId === o.id ? W.me.avatarVisible ? o.photoUrl || w.avatarUrl : null : w.avatarUrl,
              fallbackUrl: w.userId === o.id && W.me.avatarVisible ? w.avatarUrl : null
            }), jsxRuntime.jsxs("div", {
              children: [jsxRuntime.jsx("b", {
                title: w.name,
                children: w.name
              }), jsxRuntime.jsx("small", {
                children: w.userId === o.id ? "Вы в топ-20" : w.title || ""
              })]
            }), jsxRuntime.jsx("em", {
              children: jsxRuntime.jsx(RatingScore, {
                points: w.points,
                mode: m
              })
            })]
          }, w.userId))
        })
      }), W.players.length === 0 && jsxRuntime.jsx("p", {
        className: "mc-rating-status",
        children: "Пока нет участников. Станьте первым!"
      })]
    }), selectedPlayer && jsxRuntime.jsx(PublicProfileModal, {
      player: selectedPlayer,
      onClose: () => setSelectedPlayer(null)
    }, selectedPlayer.userId)]
  });
}
